import React from 'react';
import { useTranslation } from 'react-i18next';
import DashboardWidget from './DashboardWidget';
import {useSelector} from "react-redux";

const Dashboard = () => {

  const { t } = useTranslation();
  const authState = useSelector((state) => state.auth);
  const isUnionAdmin = authState?.user?.roles?.includes('UNION_ADMIN');
  const canManageSysOptionsAndUsers = Boolean(authState?.user?.canManageSysOptionsAndUsers);
  const canManageSettings = Boolean(authState?.user?.canManageSettings);
  const showAllWidgets = Boolean(isUnionAdmin);
  const canAccessSysOptionsAndUsers = showAllWidgets || canManageSysOptionsAndUsers;
  const canAccessSettings = showAllWidgets || canManageSettings;

  return (
    <div className="container">
      <div className="row g-4 py-5 row-cols-1 row-cols-md-3">


        {canAccessSysOptionsAndUsers && (
        <div className="col">
          <DashboardWidget id="crdManageSystem" icon="fa-cogs" label={t('navigation:lnkSystem')} url="/app/settings" />
        </div>
        )}

        {canAccessSysOptionsAndUsers && (
        <div className="col">
          <DashboardWidget id="crdManageUsers" icon="fa-users" label={t('navigation:lnkUsers')} url="/app/users" />
        </div>
        )}

        {canAccessSettings && (
        <div className="col">
          <DashboardWidget id="crdManageCountries" icon="fa-globe-europe" label={t('navigation:lnkCountries')} url="/app/countries" />
        </div>
        )}

        {canAccessSettings && (
        <div className="col">
          <DashboardWidget id="crdManageCodeList" icon="fa-list" label={t('navigation:lnkCodelist')} url="/app/codelists" />
        </div>
        )}

        <div className="col">
          <DashboardWidget id="crdManageActivity" icon="fa-history" label={t('navigation:lnkActivity')} url="/app/activity" />
        </div>

        {canAccessSettings && (
        <div className="col">
          <DashboardWidget id="crdApiKeys" icon="fa-key" label={t('navigation:lnkAPIKeys')} url="/app/apikeys" />
        </div>
        )}

        {canAccessSettings && (
        <div className="col">
          <DashboardWidget id="crdApiLogs" icon="fa-file-lines" label={t('navigation:lnkAPILogs')} url="/app/apiLog" />
        </div>
        )}

        {canAccessSettings && (
        <div className="col">
          <DashboardWidget id="crdIDPs" icon="fa-user-shield" label={t('navigation:lnkIDPs')} url="/app/idpSettings" />
        </div>
        )}
      </div>
    </div>
  );
};


export default Dashboard;
